export default __webpack_public_path__ + "static/media/PHCS-Logo.b093b5c3.png";